// @ts-nocheck
import {
  Inject, Injectable, Renderer2, RendererFactory2,
} from '@angular/core';
import { forEach } from 'lodash';
import { asapScheduler, interval, Subscription } from 'rxjs';
import { P } from './ui-kit';

@Injectable({
  providedIn: 'root',
})
export class UiKitService {
  get window(): {
    zESettings?: any
  } & Window {
    return window;
  }

  get standalone(): boolean {
    return (navigator as any).standalone
      || matchMedia('(display-mode: standalone)').matches;
  }

  private renderer: Renderer2;

  constructor(
    @Inject('config') private config,
    rendererFactory: RendererFactory2,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   *
   */
  public trackById(index: number, obj: { [key: string]: any }): string {
    return obj?.id;
  }

  /**
   *
   */
  public trackByIndex(index: number, obj: { [key: string]: any }): number {
    return index;
  }

  /**
   *
   */
  public clearSubscription(key: string, dictionary: P.Dictionary<Subscription>): void {
    const subscription = dictionary[key];
    if (subscription) {
      subscription.unsubscribe();
    }
    delete dictionary[key];
  }

  /**
   *
   */
  public clearSubscriptions(dictionary: P.Dictionary<Subscription>): void {
    forEach(Object
      .keys(dictionary), (key) => this.clearSubscription(key, dictionary));
  }

  /**
   * target 3rd party window objects
   */
  public windowObject(
    key: 'zE' | 'Calendly' | 'Trustpilot' | 'appzi',
    prop: string,
    callback: (obj: any) => void,
    delay: number = 300,
  ): void {
    let isLoaded: boolean;
    switch (key) {
      case 'zE':
        isLoaded = !!document?.querySelector('#ze-snippet');
        if (!isLoaded) {
          // zendesk settings
          this.window.zESettings = this.config.zendeskSettings;
          // load zendesk script
          const zendeskScript = document?.createElement('script');
          zendeskScript.id = 'ze-snippet';
          zendeskScript.src = '//static.zdassets.com/ekr/snippet.js?key=ab9240c5-2a2d-4536-93a3-5a1beceeff7b';
          zendeskScript.type = 'text/javascript';
          this.renderer.appendChild(document?.body, zendeskScript);
          // hide zendesk by default
          this.windowObject('zE', 'hide', (zendesk) => {
            zendesk('webWidget', 'hide');
            zendesk('webWidget:on', 'chat:unreadMessages', (n: number) => {
              if (zendesk?.activate) {
                zendesk.activate({ hideOnClose: true });
              }
            });
          }, 0);
        }
        break;
      case 'Calendly':
        isLoaded = !!document?.querySelector('#calendly-snippet');
        if (!isLoaded) {
          // load calendly style
          const calendlyLink = document?.createElement('link');
          calendlyLink.id = 'calendly-snippet';
          calendlyLink.href = '//assets.calendly.com/assets/external/widget.css';
          calendlyLink.rel = 'stylesheet';
          this.renderer.appendChild(document?.body, calendlyLink);
          // load calendly script
          const calendlyScript = document?.createElement('script');
          calendlyScript.src = '//assets.calendly.com/assets/external/widget.js';
          calendlyScript.type = 'text/javascript';
          this.renderer.appendChild(document?.body, calendlyScript);
        }
        break;
      case 'Trustpilot':
        isLoaded = !!document?.querySelector('#trustpilot-snippet');
        if (!isLoaded) {
          // load trustpilot script
          const trustpilotScript = document?.createElement('script');
          trustpilotScript.id = 'trustpilot-snippet';
          trustpilotScript.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
          trustpilotScript.type = 'text/javascript';
          trustpilotScript.async = true;
          this.renderer.appendChild(document?.body, trustpilotScript);
        }
        break;
      case 'appzi':
        isLoaded = !!document?.querySelector('#appzi-snippet');
        if (!isLoaded) {
          // load appzi script
          const appziScript = document?.createElement('script');
          appziScript.id = 'appzi-snippet';
          appziScript.src = 'https://w.appzi.io/bootstrap/bundle.js?token=KqldC';
          appziScript.type = 'text/javascript';
          appziScript.async = true;
          this.renderer.appendChild(document?.body, appziScript);
        }
        break;
      default:
        isLoaded = !!window[key];
    }
    //
    const subscriptionDictionary: P.Dictionary<Subscription> = {};
    const subscription = `${key}-${prop}-schedule-${+new Date()}`;

    // && window[key].hasOwnProperty(prop)
    if (window[key]) {
      this.clearSubscription(subscription, subscriptionDictionary);
      subscriptionDictionary[subscription] = asapScheduler
        .schedule(() => {
          callback(window[key]);
          this.clearSubscription(subscription, subscriptionDictionary);
        }, delay);
    } else {
      let i = 0;
      const intervalId = `${key}-${prop}-${+new Date()}`;
      subscriptionDictionary[intervalId] = interval(100)
        .subscribe(() => {
          // && window[key].hasOwnProperty(prop)
          if (window[key]) {
            this.clearSubscription(intervalId, subscriptionDictionary);
            subscriptionDictionary[subscription] = asapScheduler
              .schedule(() => {
                callback(window[key]);
                this.clearSubscription(subscription, subscriptionDictionary);
              }, delay);
          } else if (i >= 100) {
            this.clearSubscription(intervalId, subscriptionDictionary);
          }
          i++;
        });
    }
  }
}
